import React from "react";
import { useLocation, useParams } from "react-router";
import { LeadDetailView } from "../../components/LeadDetailView";

/** Gen admin lead card — same detail the exhibitor sees. */
export function AdminCompanyLeadDetailPage() {
  const { id, companyId, leadId } = useParams<{
    id: string;
    companyId: string;
    leadId: string;
  }>();
  const { pathname } = useLocation();
  const direction = pathname.includes("/you-scanned") ? "outbound" : "inbound";

  if (!id || !companyId || !leadId) {
    return <div className="p-6 text-gray-500 text-[14px]">Лид не найден</div>;
  }

  const backTo =
    direction === "outbound"
      ? `/events/${id}/exhibitors/${companyId}/you-scanned`
      : `/events/${id}/exhibitors/${companyId}/leads`;

  return (
    <LeadDetailView eventId={id} leadId={leadId} audience="admin" backTo={backTo} />
  );
}
